import { Avatar } from "@mui/material"
import type { FC } from "react"

import type { SalesRequester } from "../types"

interface ManagerAvatarProps {
  manager: Pick<SalesRequester, "firstName" | "lastName" | "initials">
}

export const isValidManagerName = (value: string | null | undefined): value is string =>
  Boolean(value && value.trim() && value.trim() !== "null")

export const ManagerAvatar: FC<ManagerAvatarProps> = ({ manager }) => {
  const display = isValidManagerName(manager.initials)
    ? manager.initials
    : `${manager.firstName?.[0] ?? ""}${manager.lastName?.[0] ?? ""}`.toUpperCase()
  return <Avatar>{display}</Avatar>
}
